export default "__VITE_ASSET__SpKofa_U__"